import React, { useCallback, useState } from 'react'
import { GridColumn as Column, Grid, GridCellProps } from '@progress/kendo-react-grid'
import { ClientDetailedDto } from 'api/Clients/Types/ClientDetailedDto'
import { DocumentDto } from 'api/Documents/Types/Document'
import { Spinner } from 'components/Spinner'
import { useApiClient } from 'utils/api/ApiClient'
import { DocumentApiClient } from 'utils/api/documentApi'
import { useFetchOne } from 'utils/api/useFetch'
import { dateComparator, formatLocalDateUTC } from 'utils/date'

import ClientDetailsVerificationReportDetails from './ClientDocumentVerificationReportDetails'

type ClientDocumentReportsProps = {
  document: DocumentDto
  reportId?: string
  client: ClientDetailedDto
}

const ClientDocumentReports: React.FC<ClientDocumentReportsProps> = ({
  document,
  reportId,
  client,
}) => {
  const [modalReportId, setModalReportId] = useState<string | null>(null)
  const documentApiClient = useApiClient(DocumentApiClient)
  const fetchData = useCallback(() => {
    if (reportId) {
      setModalReportId(reportId)
    }
    return documentApiClient.getDocumentReportsByDocumentId(document.id)
  }, [document.id, reportId]) // eslint-disable-line react-hooks/exhaustive-deps
  const { data, isLoading } = useFetchOne(fetchData)

  const sortedData = () =>
    (data || []).sort((a, b) => dateComparator(a.createdDate, b.createdDate, true))

  if (isLoading) {
    return <Spinner />
  }
  if (!data) {
    return <Grid data={[]} />
  }

  return (
    <React.Fragment>
      {modalReportId ? (
        <ClientDetailsVerificationReportDetails
          reportId={modalReportId}
          client={`${client.firstname} ${client.lastname}`}
        />
      ) : (
        <Grid data={sortedData()} resizable>
          <Column field='provider.name' title='Provider' className='table-columns__content' />
          <Column field='status.name' title='Status' className='table-columns__content' />
          <Column
            cell={(props: GridCellProps) => {
              return (
                <td
                  onClick={() => setModalReportId(props.dataItem.reportId)}
                  style={{ color: 'var(--link)', textDecoration: 'underline', cursor: 'pointer' }}
                >
                  {props.dataItem.reportId}
                </td>
              )
            }}
            title='Report Id'
            className='table-columns__content'
          />
          <Column
            cell={(props: GridCellProps) => (
              <td className='transaction-columns__date'>
                {formatLocalDateUTC(props.dataItem.createdDate, true)}
              </td>
            )}
            field='createdDate'
            title='Created Date'
            className='table-columns__date'
          />
        </Grid>
      )}
    </React.Fragment>
  )
}

export default ClientDocumentReports
